// Gets environment variable from config mounted at runtime
// This way we can configure a container without requiring rebuild
export const getEnvironmentVariable = (variable_name: string) => {
  return (
    (window["config"] && window["config"][variable_name]) ||
    process.env[variable_name]
  );
};
